import React, { PureComponent, Component } from 'react'
import { connect } from 'react-redux'

// actions
import { getCompany, getCompanyFeatures, updateCompany } from '../../../actions/company'
import { startLoading, stopLoading } from '../../../actions/loading'
import { fetchEmployees, fetchAdminEmployees } from '../../../actions/employee'
import { getMetrc } from '../../../actions/thirdParty'
// local components
import CompanyInfo from '../../../components/CompanyInfo'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import EditableHOCWrapper from '../../HOC/EditableHOC'
import { Appcues } from '../../../utils/constants'
import { isValidString } from '../../../utils/string'
import { getSettingConfig, updateSettingConfig } from '../../../actions/shopSetting'
import { openErrorMessage } from '../../../actions/message'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Input,
  InputLabel,
} from '@material-ui/core'

const CompanyInfoEditable = EditableHOCWrapper(CompanyInfo)

class CompanyInfoContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      updatedData: null,
      afterOnSave: null,
      multilicense: {
        enableMultilicense: false,
        distributionLicense: '',
        distributionDriver: '',
        distributionVehicle: '',
        distributionVehicleLicensePlate: '',
      },
      metrcSettings: null,
    }
  }

  componentDidMount() {
    this.props.dispatch(getCompany())
    this.props.dispatch(getCompanyFeatures())
    this.props.dispatch(fetchEmployees())
    this.props.dispatch(fetchAdminEmployees())
    this.props.dispatch(getSettingConfig('MULTILICENSES')).then((res) => {
      this.setState({
        multilicense: res,
      })
    })
    this.props.dispatch(getMetrc()).then((res) => {
      this.setState({
        metrcSettings: res[0],
      })
    })
  }

  onChangeMultilicense = (key, value) => {
    this.setState((prevState) => ({
      multilicense: {
        ...prevState.multilicense,
        [key]: value,
      },
    }))
  }

  onSave = (data, afterOnSave) => {
    this.props.dispatch(startLoading())
    const multilicenseData = JSON.stringify(this.state.multilicense)
    if (this.state.multilicense && this.state.multilicense.enableMultilicense) {
      this.props.dispatch(stopLoading())
      this.setState({
        modal: true,
        updatedData: data,
        afterOnSave: afterOnSave,
      })
      this.confirmDeleteModal = true
    } else {
      this.props.dispatch(updateCompany(data)).then((response) => {
        Appcues.track('Company Info saved')
        afterOnSave(response)
        this.props.dispatch(stopLoading())
      })
      this.props.dispatch(updateSettingConfig(multilicenseData, 'MULTILICENSES'))
    }
  }

  onCloseModal = () => {
    this.setState({
      modal: false,
    })
  }

  onConfirm = () => {
    const { updatedData, multilicense, afterOnSave } = this.state
    const multilicenseData = JSON.stringify(multilicense)

    this.props.dispatch(updateCompany(updatedData)).then((response) => {
      Appcues.track('Company Info saved')
      afterOnSave(response)
      this.props.dispatch(stopLoading())
      this.onCloseModal()
    })
    this.props.dispatch(updateSettingConfig(multilicenseData, 'MULTILICENSES'))
  }

  onChange = (e) => {
    const { multilicense } = this.state
    multilicense[e.target.name] = e.target.value
    this.setState({
      multilicense: multilicense,
    })
  }

  onError = (message) => this.props.dispatch(openErrorMessage(message))

  validateOnConfirm = () => {
    const { multilicense } = this.state

    if (multilicense.enableMultilicense) {
      if (!isValidString(multilicense.distributionLicense)) {
        this.onError('Please provide a Distribution License')
        return
      }

      if (!isValidString(multilicense.distributionDriver)) {
        this.onError('Please provide a Distribution Driver Name')
        return
      }

      if (!isValidString(multilicense.distributionVehicle)) {
        this.onError('Please provide a Distribution Vehicle')
        return
      }

      if (!isValidString(multilicense.distributionVehicleLicensePlate)) {
        this.onError('Please provide a Distribution Vehicle Lincense Plate')
        return
      }
    }

    this.onConfirm()
  }

  render() {
    const { company = {}, companyFeatures = {}, lastModified = null } = this.props.companyReducer

    const { session = {}, employees = [], adminsEmployees } = this.props.employeeReducer || {}

    const { multilicense, modal, metrcSettings } = this.state

    const {
      distributionLicense,
      distributionDriver,
      distributionVehicle,
      distributionVehicleLicensePlate,
    } = this.state.multilicense

    return (
      <div>
        <CompanyInfoEditable
          dataToEdit={company}
          onSave={this.onSave}
          lastModified={lastModified}
          employees={employees || []}
          adminsEmployees={adminsEmployees || []}
          companyFeatures={companyFeatures}
          shops={session ? session.employeeShops : []}
          employee={session ? session.employee : []}
          dispatch={this.props.dispatch}
          multilicense={multilicense}
          metrcSettings={metrcSettings}
          onChangeMultilicense={this.onChangeMultilicense}
        />

        <Dialog
          open={modal}
          className={'container-confirmation-modal'}
          style={{ display: 'block', textAlign: '-webkit-center' }}
        >
          <DialogTitle style={{ paddingBottom: 5 }}>Multi-license Feature Confirmation</DialogTitle>
          <DialogContent className={'size-modal'} style={{ textAlign: 'initial' }}>
            <br></br>
            <div className={'center-dropdown'}>
              <InputLabel>Distribution License *</InputLabel>
              <Input
                placeholder="Distribution License"
                fullWidth
                name="distributionLicense"
                value={distributionLicense}
                onChange={this.onChange}
                style={{ margin: '10px 0px' }}
              />
              <InputLabel>Driver Name *</InputLabel>
              <Input
                placeholder="Driver Name"
                fullWidth
                name="distributionDriver"
                value={distributionDriver}
                onChange={this.onChange}
                style={{ margin: '10px 0px' }}
              />
              <InputLabel>Vehicle *</InputLabel>
              <Input
                placeholder="Vehicle"
                fullWidth
                name="distributionVehicle"
                value={distributionVehicle}
                onChange={this.onChange}
                style={{ margin: '10px 0px' }}
              />
              <InputLabel>Vehicle License Plate *</InputLabel>
              <Input
                placeholder="Vehicle License Plate"
                fullWidth
                name="distributionVehicleLicensePlate"
                value={distributionVehicleLicensePlate}
                onChange={this.onChange}
                style={{ margin: '10px 0px' }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.onCloseModal(false)
              }}
              className="button-white-and-red"
            >
              <span className="button-text">Cancel</span>
            </Button>
            <Button className="button-blue-and-white" onClick={() => this.validateOnConfirm()}>
              <span className="button-text">Confirm</span>
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

const CompanyInfoWithTitle = ContainerWithTitle(CompanyInfoContainer, 'Company Information')
const CompanyInfoConnected = connect(({ dispatch, companyReducer, employeeReducer }) => ({
  dispatch,
  companyReducer,
  employeeReducer,
}))(CompanyInfoWithTitle)

export default CompanyInfoConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/CompanyInfo.js